import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import "select2/dist/css/select2.min.css"; // ✅ global style
import "select2";

createApp(App).use(router).mount("#app");
